import { handleActions, createAction } from 'redux-actions';
import update from 'immutability-helper';
import mapActions from '@goodwaygroup/react-map-actions';

// Actions
export const actions = mapActions([
    'FETCH_ACTIONS_BY_OBJECTIVE_SUCCESS',
    'FETCH_ACTIONS_BY_OBJECTIVE',
    'FETCH_ACTIONS_SUCCESS',
    'FETCH_ACTIONS',
    'FETCH_ADS_BY_OBJECTIVE_SUCCESS',
    'FETCH_ADS_BY_OBJECTIVE',
    'FETCH_ADS_SUCCESS',
    'FETCH_ADS',
    'FETCH_ADSETS_BY_OBJECTIVE_SUCCESS',
    'FETCH_ADSETS_BY_OBJECTIVE',
    'FETCH_ADSETS_SUCCESS',
    'FETCH_ADSETS',
    'FETCH_CALLOUTS_BY_OBJECTIVE_SUCCESS',
    'FETCH_CALLOUTS_BY_OBJECTIVE',
    'FETCH_CAMPAIGNS_SUCCESS',
    'FETCH_CAMPAIGNS',
    'FETCH_CAMPS_BY_OBJECTIVE_SUCCESS',
    'FETCH_CAMPS_BY_OBJECTIVE',
    'FETCH_DATA_BY_OBJECTIVE_SUCCESS',
    'FETCH_DATA_BY_OBJECTIVE',
    'FETCH_DEMOGRAPHICS_BY_OBJECTIVE_SUCCESS',
    'FETCH_DEMOGRAPHICS_BY_OBJECTIVE',
    'FETCH_DEMOGRAPHICS_SUCCESS',
    'FETCH_DEMOGRAPHICS',
    'FETCH_UNIQUE_MEASURES_BY_OBJECTIVE_SUCCESS',
    'FETCH_UNIQUE_MEASURES_BY_OBJECTIVE',
    'FETCH_UNIQUE_MEASURES_SUCCESS',
    'FETCH_UNIQUE_MEASURES',
    'TOGGLE_OBJECTIVE_EXPANSION',
    'EXPAND_ALL_OBJECTIVES',
    'RESET_TO_INITIAL_STATE',
], 'SOCIAL');


// Action Creators
export const fetchSocialDataByObjective =
    createAction(actions.FETCH_DATA_BY_OBJECTIVE, params => params);
export const socialDataByObjectiveFetched =
    createAction(actions.FETCH_DATA_BY_OBJECTIVE_SUCCESS, data => data);

export const fetchSocialCampaigns = createAction(actions.FETCH_CAMPAIGNS, params => params);
export const socialCampaignsFetched = createAction(actions.FETCH_CAMPAIGNS_SUCCESS, data => data);
export const fetchSocialCampaignsByObjective =
    createAction(actions.FETCH_CAMPS_BY_OBJECTIVE, params => params);
export const socialCampaignsByObjectiveFetched =
    createAction(actions.FETCH_CAMPS_BY_OBJECTIVE_SUCCESS, data => data);

export const fetchSocialAdSets = createAction(actions.FETCH_ADSETS, params => params);
export const socialAdSetsFetched = createAction(actions.FETCH_ADSETS_SUCCESS, data => data);
export const fetchSocialAdSetsByObjective =
    createAction(actions.FETCH_ADSETS_BY_OBJECTIVE, params => params);
export const socialAdSetsByObjectiveFetched =
    createAction(actions.FETCH_ADSETS_BY_OBJECTIVE_SUCCESS, data => data);

export const fetchSocialAds = createAction(actions.FETCH_ADS, params => params);
export const socialAdsFetched = createAction(actions.FETCH_ADS_SUCCESS, data => data);
export const fetchSocialAdsByObjective =
    createAction(actions.FETCH_ADS_BY_OBJECTIVE, params => params);
export const socialAdsByObjectiveFetched =
    createAction(actions.FETCH_ADS_BY_OBJECTIVE_SUCCESS, data => data);

export const fetchSocialCalloutsByObjective =
    createAction(actions.FETCH_CALLOUTS_BY_OBJECTIVE, params => params);
export const socialCalloutsByObjectiveFetched =
    createAction(actions.FETCH_CALLOUTS_BY_OBJECTIVE_SUCCESS, data => data);

export const fetchSocialActions = createAction(actions.FETCH_ACTIONS, params => params);
export const socialActionsFetched = createAction(actions.FETCH_ACTIONS_SUCCESS, data => data);
export const fetchSocialActionsByObjective =
    createAction(actions.FETCH_ACTIONS_BY_OBJECTIVE, params => params);
export const socialActionsByObjectiveFetched =
    createAction(actions.FETCH_ACTIONS_BY_OBJECTIVE_SUCCESS, data => data);

export const fetchSocialDemographics = createAction(actions.FETCH_DEMOGRAPHICS, params => params);
export const socialDemographicsFetched = createAction(actions.FETCH_DEMOGRAPHICS_SUCCESS, data => data);
export const fetchSocialDemographicsByObjective =
    createAction(actions.FETCH_DEMOGRAPHICS_BY_OBJECTIVE, params => params);
export const socialDemographicsByObjectiveFetched =
    createAction(actions.FETCH_DEMOGRAPHICS_BY_OBJECTIVE_SUCCESS, data => data);

export const fetchSocialUniqueMeasures = createAction(actions.FETCH_UNIQUE_MEASURES, params => params);
export const socialUniqueMeasuresFetched = createAction(actions.FETCH_UNIQUE_MEASURES_SUCCESS, data => data);
export const fetchSocialUniqueMeasuresByObjective =
    createAction(actions.FETCH_UNIQUE_MEASURES_BY_OBJECTIVE, params => params);
export const socialUniqueMeasuresByObjectiveFetched =
    createAction(actions.FETCH_UNIQUE_MEASURES_BY_OBJECTIVE_SUCCESS, data => data);

export const resetSocialInitialState = createAction(actions.RESET_TO_INITIAL_STATE);
export const toggleObjectiveExpansion = createAction(actions.TOGGLE_OBJECTIVE_EXPANSION, objective => objective);
export const expandAllObjectives = createAction(actions.EXPAND_ALL_OBJECTIVES);

// Reducers
const objectiveInitialState = {
    actions: {},
    ads: {},
    adsets: {
        hasData: null
    },
    callouts: {},
    campaigns: {
        hasData: null
    },
    timeData: {
        hasData: null
    },
    demographics: {
        hasData: null
    },
    uniqueMeasures: {
        campaign: {},
        adset: {},
        ad: {}
    },
    expand: {
        hide: true,
        initialExpand: false
    }
};

const initialState = {
    facebook: {
        ads: {
            hasData: null
        },
        actions: {
            hasData: null
        },
        adsets: {
            hasData: null
        },
        campaigns: {
            hasData: null
        },
        demographics: {
            hasData: null
        },
        uniqueMeasures: {
            campaign: {},
            adset: {},
            ad: {}
        },
        objectives: {
            APP_INSTALLS: objectiveInitialState,
            BRAND_AWARENESS: objectiveInitialState,
            CONVERSIONS: objectiveInitialState,
            EVENT_RESPONSES: objectiveInitialState,
            LEAD_GENERATION: objectiveInitialState,
            LINK_CLICKS: objectiveInitialState,
            LOCAL_AWARENESS: objectiveInitialState,
            MESSAGES: objectiveInitialState,
            OFFER_CLAIMS: objectiveInitialState,
            PAGE_LIKES: objectiveInitialState,
            POST_ENGAGEMENT: objectiveInitialState,
            PRODUCT_CATALOG_SALES: objectiveInitialState,
            REACH: objectiveInitialState,
            STORE_VISITS: objectiveInitialState,
            VIDEO_VIEWS: objectiveInitialState,
            OUTCOME_SALES: objectiveInitialState,
            OUTCOME_LEADS: objectiveInitialState
        }
    }
};

export default handleActions({

    [actions.FETCH_CAMPAIGNS_SUCCESS]: (state, action) => {
        const { payload } = action;
        const hasData = payload.params.hasData;
        const setObj = {
            hasData: { $set: hasData }
        };

        if (hasData) {
            const reducedSets = Object.keys(payload.data).reduce((prev, key) => {
                prev[key] = { $set: payload.data[key] };
                return prev;
            }, {});

            reducedSets.scopeKey = { $set: payload.data.categories.config.selector };
            reducedSets.xAxisLabel = { $set: payload.data.categories.config.xAxisLabel };

            Object.assign(setObj, reducedSets);
        }

        const updatedData = {
            facebook: {
                campaigns: setObj
            }
        };
        return update(state, updatedData);
    },

    [actions.FETCH_CAMPS_BY_OBJECTIVE_SUCCESS]: (state, action) => {
        const { payload } = action;
        const { objective } = payload;
        const hasData = payload.params.hasData;
        const setObj = {
            hasData
        };

        if (hasData) {
            payload.data.scopeKey = payload.data.categories.config.selector;
            payload.data.xAxisLabel = payload.data.categories.config.xAxisLabel;

            Object.assign(setObj, payload.data);
        }

        const updatedData = {
            facebook: {
                objectives: {
                    [objective]: {
                        campaigns: {
                            $set: setObj
                        }
                    }
                }
            }
        };
        return update(state, updatedData);
    },

    [actions.FETCH_ADSETS_SUCCESS]: (state, action) => {
        const { payload } = action;
        const hasData = payload.params.hasData;
        const setObj = {
            hasData: { $set: hasData }
        };

        if (hasData) {
            const reducedSets = Object.keys(payload.data).reduce((prev, key) => {
                prev[key] = { $set: payload.data[key] };
                return prev;
            }, {});

            reducedSets.scopeKey = { $set: payload.data.categories.config.selector };
            reducedSets.xAxisLabel = { $set: payload.data.categories.config.xAxisLabel };

            Object.assign(setObj, reducedSets);
        }

        const updatedData = {
            facebook: {
                adsets: setObj
            }
        };
        return update(state, updatedData);
    },

    [actions.FETCH_ADSETS_BY_OBJECTIVE_SUCCESS]: (state, action) => {
        const { payload } = action;
        const { objective } = payload;
        const hasData = payload.params.hasData;
        const setObj = {
            hasData
        };

        if (hasData) {
            payload.data.scopeKey = payload.data.categories.config.selector;
            payload.data.xAxisLabel = payload.data.categories.config.xAxisLabel;

            Object.assign(setObj, payload.data);
        }

        const updatedData = {
            facebook: {
                objectives: {
                    [objective]: {
                        adsets: {
                            $set: setObj
                        }
                    }
                }
            }
        };
        return update(state, updatedData);
    },

    [actions.FETCH_ADS_SUCCESS]: (state, action) => {
        const { payload } = action;
        const hasData = payload.params.hasData;
        const setObj = {
            hasData: { $set: hasData }
        };

        if (hasData) {
            const reducedAds = Object.keys(payload.data).reduce((prev, key) => {
                prev[key] = { $set: payload.data[key] };
                return prev;
            }, {});

            reducedAds.scopeKey = { $set: payload.data.categories.config.selector };
            reducedAds.xAxisLabel = { $set: payload.data.categories.config.xAxisLabel };

            Object.assign(setObj, reducedAds);
        }

        const updatedData = {
            facebook: {
                ads: setObj
            }
        };
        return update(state, updatedData);
    },

    [actions.FETCH_ADS_BY_OBJECTIVE_SUCCESS]: (state, action) => {
        const { payload } = action;
        const { objective } = payload;
        const hasData = payload.params.hasData;
        const setObj = {
            hasData
        };

        if (hasData) {
            payload.data.scopeKey = payload.data.categories.config.selector;
            payload.data.xAxisLabel = payload.data.categories.config.xAxisLabel;

            Object.assign(setObj, payload.data);
        }

        const updatedData = {
            facebook: {
                objectives: {
                    [objective]: {
                        ads: {
                            $set: setObj
                        }
                    }
                }
            }
        };
        return update(state, updatedData);
    },

    [actions.FETCH_CALLOUTS_BY_OBJECTIVE_SUCCESS]: (state, action) => update(state, {
        facebook: {
            objectives: {
                [action.payload.objective]: {
                    callouts: { $set: action.payload }
                }
            }
        }
    }),

    [actions.FETCH_DATA_BY_OBJECTIVE_SUCCESS]: (state, action) => {
        const { hasData } = action.payload.params;
        let updatedData = { hasData };

        if (hasData) {
            const scopeKey = action.payload.categories.config.selector;

            updatedData = {
                hasData,
                data: action.payload[scopeKey],
                statistics: action.payload.statistics,
                categories: action.payload.categories[scopeKey],
                xAxisLabel: action.payload.categories.config.xAxisLabel,
            };
        }

        return update(state, {
            facebook: {
                objectives: {
                    [action.payload.objective]: {
                        timeData: { $set: updatedData }
                    }
                }
            }
        });
    },

    [actions.FETCH_ACTIONS_SUCCESS]: (state, action) => {
        const { payload } = action;
        const hasData = payload.params.hasData;
        const setObj = {
            hasData: { $set: hasData }
        };

        if (hasData) {
            const reducedSets = Object.keys(payload.data).reduce((prev, key) => {
                prev[key] = { $set: payload.data[key] };
                return prev;
            }, {});

            Object.assign(setObj, reducedSets);
        }

        const updatedData = {
            facebook: {
                actions: setObj
            }
        };
        return update(state, updatedData);
    },

    [actions.FETCH_ACTIONS_BY_OBJECTIVE_SUCCESS]: (state, action) => {
        const { payload } = action;
        const { objective } = payload;
        const hasData = payload.params.hasData;
        const setObj = {
            hasData
        };

        if (hasData) {
            Object.assign(setObj, payload.data);
        }

        const updatedData = {
            facebook: {
                objectives: {
                    [objective]: {
                        actions: {
                            $set: setObj
                        }
                    }
                }
            }
        };
        return update(state, updatedData);
    },

    [actions.FETCH_DEMOGRAPHICS_SUCCESS]: (state, action) => {
        const { payload } = action;
        const hasData = payload.params.hasData;
        const setObj = { hasData };

        if (hasData) {
            Object.assign(setObj, payload);
        }

        const updatedData = {
            facebook: {
                demographics: { $set: setObj }
            }
        };
        return update(state, updatedData);
    },

    [actions.FETCH_DEMOGRAPHICS_BY_OBJECTIVE_SUCCESS]: (state, action) => {
        const { payload } = action;
        const { objective } = payload;
        const hasData = payload.params.hasData;
        const setObj = { hasData };

        if (hasData) {
            Object.assign(setObj, payload);
        }

        const updatedData = {
            facebook: {
                objectives: {
                    [objective]: {
                        demographics: {
                            $set: setObj
                        }
                    }
                }
            }
        };
        return update(state, updatedData);
    },


    [actions.FETCH_UNIQUE_MEASURES_SUCCESS]: (state, action) => {
        const { payload } = action;
        const { grain = 'campaign' } = payload;
        const hasData = payload.params.hasData;
        const setObj = {
            hasData: { $set: hasData }
        };

        if (hasData) {
            const reducedSets = Object.keys(payload.data).reduce((prev, key) => {
                prev[key] = { $set: payload.data[key] };
                return prev;
            }, {});

            Object.assign(setObj, reducedSets);
        }

        const updatedData = {
            facebook: {
                uniqueMeasures: {
                    [grain]: setObj
                }
            }
        };
        return update(state, updatedData);
    },

    [actions.FETCH_UNIQUE_MEASURES_BY_OBJECTIVE_SUCCESS]: (state, action) => {
        const { payload } = action;
        const { objective, grain = 'campaign' } = payload;
        const hasData = payload.params.hasData;
        const setObj = {
            hasData
        };

        if (hasData) {
            Object.assign(setObj, payload.data);
        }

        const updatedData = {
            facebook: {
                objectives: {
                    [objective]: {
                        uniqueMeasures: {
                            [grain]: {
                                $set: setObj
                            }
                        }
                    }
                }
            }
        };
        return update(state, updatedData);
    },

    [actions.RESET_TO_INITIAL_STATE]: state => update(state, { $set: initialState }),

    [actions.TOGGLE_OBJECTIVE_EXPANSION]: (state, action) => update(state, {
        facebook: {
            objectives: {
                [action.payload]: {
                    expand: {
                        initialExpand: { $set: true },
                        $toggle: ['hide']
                    }
                }
            }
        }
    }),

    [actions.EXPAND_ALL_OBJECTIVES]: state => update(state, {
        facebook: {
            objectives: Object.keys(initialState.facebook.objectives).reduce((prev, key) => {
                prev[key] = {
                    expand: {
                        initialExpand: { $set: true },
                        hide: { $set: false }
                    }
                };
                return prev;
            }, {})
        }
    }),

}, initialState);



// WEBPACK FOOTER //
// ./src/services/social/duck.js